import React from "react";

import { MenuRounded, SearchRounded, SettingsRounded } from "@mui/icons-material";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

import useMainState from "../../../config/context/mainStateContext";
import useCafeteria from "../context";

import MainSolidButton from "../../../components/MainSolidButton";
import PageHeader from "../../../components/PageHeader";

export default function OrderTab() {
  const navigate = useNavigate();

  const { setShowSideMenuDrawer } = useMainState();

  const { currentCafeteria } = useCafeteria();

  React.useEffect(() => {}, []);

  return (
    <Box>
      <PageHeader
        title="Lanchonete"
        leftIcon={<MenuRounded />}
        onLeftAction={() => setShowSideMenuDrawer(true)}
        rightIcon={<SettingsRounded />}
        onRightAction={() => navigate("/cafeteria/settings")}
      />

      <MainSolidButton text="Pesquisar" icon={<SearchRounded />} onClick={() => {}} />
    </Box>
  );
}
